import React from 'react';
import { DetailsWrapper } from './DetailsWrapper';
import cn from './styles.module.scss';

export const ApplicationDetails = ({ application }) => {
  return (
    <div className={cn.details}>
      <DetailsWrapper title="Member Information">
        <span>Membership ID #:</span>
        <span>{application.membership_id}</span>
        <span>First Name:</span>
        <span>{application.member_firstname}</span>
        <span>Last Name:</span>
        <span>{application.member_lastname}</span>
        <span>Current Legal Address:</span>
        <span>{application.member_current_legal_address}</span>
        <span>City:</span>
        <span>{application.member_city}</span>
        <span>Country:</span>
        <span>{application.member_country}</span>
        <span>State:</span>
        <span>{application.member_state_or_province}</span>
        <span>Zip Code:</span>
        <span>{application.member_zipcode}</span>
        <span>DOB:</span>
        <span>{application.member_dob}</span>
        <span>Gender:</span>
        <span>{application.member_sex}</span>
        <span>Last 4 Of SSN:</span>
        <span>{application.member_social_security_number}</span>
        <span>Cell Phone:</span>
        <span>{application.member_home_phone_number}</span>
        <span>Email:</span>
        <span>{application.member_email}</span>
      </DetailsWrapper>
      {!!application.member_is_different_billing_address && (
        <DetailsWrapper title="Billing Address">
          <span>Address:</span>
          <span>{application.member_billing_address}</span>
          <span>City:</span>
          <span>{application.member_billing_city}</span>
          <span>Country:</span>
          <span>{application.member_billing_country}</span>
          <span>State:</span>
          <span>{application.member_billing_state_or_province}</span>
          <span>Zip Code:</span>
          <span>{application.member_billing_zipcode}</span>
        </DetailsWrapper>
      )}
      <DetailsWrapper title="Agent Information">
        <span>APASI Agent ID:</span>
        <span>{application.agent_id}</span>
      </DetailsWrapper>
      <DetailsWrapper title="Travel Assurence Plan Information">
        <span>Travel Assurence Plan:</span>
        <span>{application.member_travel_assurence_plan}</span>
        <span>Type of Payment:</span>
        <span>{application.member_travel_assurence_plan_months}</span>
        <span>Price of Plan:</span>
        <span>{application.member_travel_assurence_plan_price}</span>
        {application.member_extra_fee && (
          <>
            <span>Extra Fee of Plan for first month:</span>
            <span>{application.member_extra_fee}</span>
          </>
        )}
      </DetailsWrapper>
      <DetailsWrapper title="Emergency contact">
        <span>First Name:</span>
        <span>{application.member_emergency_firstname}</span>
        <span>Last Name:</span>
        <span>{application.member_emergency_lastname}</span>
        <span>Email:</span>
        <span>{application.member_emergency_email}</span>
        <span>Phone:</span>
        <span>{application.member_emergency_phone_number}</span>
      </DetailsWrapper>
      <DetailsWrapper title="Funeral Home">
        <span>ID:</span>
        <span>{application.member_funeral_home_id}</span>
        <span>Name:</span>
        <span>{application.member_funeral_home_name}</span>
        <span>City:</span>
        <span>{application.member_funeral_home_city}</span>
        <span>State:</span>
        <span>{application.member_funeral_home_state}</span>
      </DetailsWrapper>
    </div>
  )
};
